import { PROJECTS_IMAGES } from "../images/works";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import PublicIcon from "@mui/icons-material/Public";

import BootstrapeSvg from "../images/svg/BootstrapSvg";

export const tabsContent = [
  {
    name: "web_Projects",
    id: 0,
    icon: <PublicIcon />,
  },
  {
    name: "mobile_Projects",
    id: 1,
    icon: <PhoneAndroidIcon />,
  },
];

export const projectsContent = [

  // TODO : add ar translation to those
    {
    ImgSrc: PROJECTS_IMAGES.Codex,
    alt: "Codex",
    projectUrl: "https://vibe-chi-nine.vercel.app/",
    hoverMsg: "hover-msg",
    projectTitle: "Codex_project_title",
    ProjectDes: "Codex_project_des",
    gitUrl:
      "https://github.com/Nadjem-47/vibe",
    projectTechStack: [
      "React",
      "Typescript",
      "Reacy query",
      "Rest API",
      "Prisma",
      "Tailwind CSS",
    ],
    isPrivate: false,
    platform: ["web"]
  },
  {
    ImgSrc: PROJECTS_IMAGES.klapper,
    alt: "klapper",
    projectUrl: "https://play.google.com/store/apps/details?id=com.klapper&hl=en_US",
    hoverMsg: "hover-msg",
    projectTitle: "klapper_project_title",
    ProjectDes: "klapper_project_des",
    gitUrl:
      "https://github.com/costaDZ/image-generator/tree/change-project-structure",
    projectTechStack: [
      "React Native",
      "Typescript",
      "Reacy query",
      "Styled components",
      "Rest API",
      "Redux persist",
      "Web Socket",
    ],
    isPrivate: true,
    platform: ["android", "ios"]
  },
  {
    ImgSrc: PROJECTS_IMAGES.image_generator,
    alt: "tesla_overlay",
    projectUrl: "https://dz-gallery.netlify.app/",
    hoverMsg: "hover-msg",
    projectTitle: "image_generator_project_title",
    ProjectDes: "image_generator_project_des",
    gitUrl:
      "https://github.com/costaDZ/image-generator/tree/change-project-structure",
    projectTechStack: [
      "React.js",
      "Typescript",
      "Redux",
      "Styled components",
      "Rest API",
      "Redux persist",
    ],
    platform: ["web"]
  },
  // {
  //   ImgSrc: PROJECTS_IMAGES.tesla_overlay,
  //   alt: "tesla_overlay",
  //   projectUrl: "https://tesla-overlay.netlify.app/",
  //   hoverMsg: "hover-msg",
  //   projectTitle: "tesla_project_title",
  //   ProjectDes: "tesla_project_des",
  //   gitUrl: "https://github.com/costaDZ/tesla_website",
  //   projectTechStack: [
  //     "React.js",
  //     "Redux",
  //     "Styled components",
  //     "React Reveal",
  //     "Redux persist",
  //   ],
  // },
  // {
  //   ImgSrc: PROJECTS_IMAGES.netflex_app,
  //   alt: "tesla_overlay",
  //   projectUrl: "https://dznetflex.netlify.app/",
  //   hoverMsg: "hover-msg",
  //   projectTitle: "netflex_title",
  //   ProjectDes: "netflex_des",
  //   gitUrl: "https://github.com/costaDZ/netflex-dz",
  //   projectTechStack: ["React.JS", "Material UI"],
  // },
];



export const mobileProjectsContent = [
  {
    ImgSrc: PROJECTS_IMAGES.klapper,
    alt: "klapper",
    projectUrl: "https://play.google.com/store/apps/details?id=com.klapper&hl=en_US",
    hoverMsg: "hover-msg",
    projectTitle: "klapper_project_title",
    ProjectDes: "klapper_project_des",
    gitUrl:
      "https://github.com/costaDZ/image-generator/tree/change-project-structure",
    projectTechStack: [
      "React Native",
      "Typescript",
      "Reacy query",
      "Styled components",
      "Rest API",
      "Redux persist",
      "Web Socket",
    ],
    isPrivate: true,
  }
];
